<template>
  <div>
    <Breadcrumb msg1="验配随访" msg2="随访记录" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6">
          <el-select v-model="query.customer_id" filterable remote placeholder="按客户搜索" :remote-method="searchCustomer" clearable style="width: 100%">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="query.followup_date" type="date" value-format="yyyy-MM-dd" placeholder="随访日期"></el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">新增</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="客户" width="100"><template slot-scope="scope">{{ customerName(scope.row.customerId) }}</template></el-table-column>
        <el-table-column label="随访日期" prop="followupDate" width="110"></el-table-column>
        <el-table-column label="检查项目" prop="items" show-overflow-tooltip></el-table-column>
        <el-table-column label="OD" prop="odResult" width="100"></el-table-column>
        <el-table-column label="OS" prop="osResult" width="100"></el-table-column>
        <el-table-column label="依从性" prop="compliance" width="90"></el-table-column>
        <el-table-column label="医嘱" prop="doctorAdvice" show-overflow-tooltip></el-table-column>
        <el-table-column label="下次随访" prop="nextFollowupDate" width="110"></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="640px" :close-on-click-modal="false">
      <el-form :model="form" label-width="110px" v-if="show">
        <el-form-item label="关联验配单">
          <el-select v-model="form.fitting_id" filterable placeholder="选择验配单" style="width: 100%">
            <el-option v-for="f in fittingOptions" :key="f.id" :label="'#' + f.id + ' ' + customerName(f.customerId) + ' ' + f.lensType + ' ' + (f.brand || '')" :value="f.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户" required>
          <el-select v-model="form.customer_id" filterable remote placeholder="输入姓名/手机号搜索" :remote-method="searchCustomer" style="width: 100%">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="随访日期"><el-date-picker v-model="form.followup_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker></el-form-item>
        <el-form-item label="检查项目"><el-input v-model="form.items" placeholder="如 视力/裂隙灯/角膜地形图"></el-input></el-form-item>
        <el-form-item label="OD 结果"><el-input v-model="form.od_result"></el-input></el-form-item>
        <el-form-item label="OS 结果"><el-input v-model="form.os_result"></el-input></el-form-item>
        <el-form-item label="依从性">
          <el-select v-model="form.compliance" style="width: 100%">
            <el-option label="良好" value="良好"></el-option>
            <el-option label="一般" value="一般"></el-option>
            <el-option label="差" value="差"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医生">
          <el-select v-model="form.doctor_id" style="width: 100%">
            <el-option v-for="doc in doctors" :key="doc.id" :label="doc.realname" :value="doc.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医嘱"><el-input v-model="form.doctor_advice" type="textarea"></el-input></el-form-item>
        <el-form-item label="下次随访"><el-date-picker v-model="form.next_followup_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker></el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { loadCustomerMap, customerName } from '@/utils/customerName'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, customer_id: null, followup_date: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: {},
      customerOptions: [],
      fittingOptions: [],
      doctors: []
    }
  },
  created () {
    this.getData()
    loadCustomerMap(this.$axios.http)
    this.$axios.http.get('/users/doctors').then(r => { if (r.data.status === 200) this.doctors = r.data.data || [] })
    this.$axios.http.get('/lensFittings', { params: { page: 1, limit: 100 } }).then(r => {
      if (r.data.status === 200) this.fittingOptions = r.data.data.records || []
    })
  },
  methods: {
    customerName,
    getData () {
      this.$axios.get('/lensFollowups', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    searchCustomer (kw) {
      if (!kw) return
      this.$axios.http.get('/customers/select', { params: { keyword: kw } }).then(r => {
        if (r.data.status === 200) this.customerOptions = r.data.data || []
      })
    },
    add () {
      this.dialogTitle = '新增随访'
      this.form = { fitting_id: null, customer_id: null, followup_date: '', items: '', od_result: '', os_result: '', compliance: '良好', doctor_advice: '', next_followup_date: '', doctor_id: null }
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑随访'
      this.form = Object.assign({}, row, {
        fitting_id: row.fittingId,
        customer_id: row.customerId,
        followup_date: row.followupDate,
        items: row.items,
        od_result: row.odResult,
        os_result: row.osResult,
        compliance: row.compliance,
        doctor_advice: row.doctorAdvice,
        next_followup_date: row.nextFollowupDate,
        doctor_id: row.doctorId
      })
      this.customerOptions = [{ id: row.customerId, name: customerName(row.customerId), phone: '' }]
      this.show = true
    },
    save () {
      if (!this.form.customer_id) { this.$message.warning('请选择客户'); return }
      if (this.form.id) {
        this.$axios.put(`/lensFollowups/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/lensFollowups', () => { this.show = false; this.getData() }, this.form)
      }
    },
    del (id) {
      this.$axios.del(`/lensFollowups/${id}`, () => this.getData())
    }
  }
}
</script>
